import { Container, Row } from "reactstrap";
import { ButtonGroupTitle, ButtonsTitle } from "../../../constants";
import GroupButtonClass from "./GroupButtonClass";
import VerticalButtonGroup from "./VerticalButtonGroup";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import RadioCheckboxButton from "./radioCheckboxButton";
import NestingButton from "./nestingButton";

const ButtonGroupContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ButtonGroupTitle} parent={ButtonsTitle} />
      <Container fluid>
        <Row>
          <GroupButtonClass />
          <RadioCheckboxButton />
          <NestingButton />
          <VerticalButtonGroup />
        </Row>
      </Container>
    </>
  );
};
export default ButtonGroupContainer;
